import { initialStrollersWishListState } from 'mk2/apps/strollers/containers/WishList/WishList.constants';
import { StrollerEntity, StrollerSchema } from 'mk2/apps/strollers/schemas';
import { AppState } from 'mk2/reducers';
import { getDenormalizedEntities } from 'mk2/selectors';

export const getStrollersWishListState = (state: AppState) =>
    state.containers.strollers.wishList || initialStrollersWishListState;
export const getStrollersWishListItems = (state: AppState) => getDenormalizedEntities<StrollerEntity>(state, StrollerSchema, getStrollersWishListState(state).wishlistItemsIds);
